/**
 * Pure helpers for the post-login product-redirect resolver/chooser.
 *
 * The client-side redirect guard: the resolver and chooser only ever navigate
 * the browser to an absolute `https://` URL. Anything else (relative path,
 * `http:`, `javascript:`/`data:`, unparseable, null) is treated as "no usable
 * destination" — the resolver falls back to `/account`, the chooser disables the
 * card. `portal_url` is validated server-side at write time (`validate_portal_url`
 * in `product_sync.rs`); this client guard is defense-in-depth.
 */

/** True iff `u` parses as an absolute `https:` URL. */
export function isLaunchableUrl(u: string | null | undefined): boolean {
  if (typeof u !== 'string' || u.length === 0) return false;
  try {
    return new URL(u).protocol === 'https:';
  } catch {
    return false;
  }
}

/** The host of a launchable URL (for the mono domain hint); `''` if unparseable. */
export function productHost(u: string): string {
  try {
    return new URL(u).host;
  } catch {
    return '';
  }
}
